export const detailPages = [
    {
        title: '근무 정보',
        cardName: 'WorkInfo',
        type: 'work-info',
    },
    {
        title: '차량면허 및 보험 정보',
        cardName: 'PrivateInfo',
        type: 'private-info',
    },
    {
        title: '배달설정',
        cardName: 'DeliverySetting',
        type: 'delivery-setting',
    },
];
export const cardDevice = {
    NOT_EXIST: {
        text: '없음',
        value: 'NOT_EXIST',
    },
    SWIPE: {
        text: 'SWIPE',
        value: 'SWIPE ',
    },
    INFINIX: {
        text: 'INFINIX',
        value: 'INFINIX ',
    },
    MAGNETIC: {
        text: '통합 마그네틱',
        value: 'MAGNETIC ',
    },
    SPP_R200: {
        text: 'SPP_R200',
        value: 'SPP_R200',
    },
    LINK_PAY: {
        text: 'LINK_PAY',
        value: 'LINK_PAY',
    },
};
